export default {
  methods: {
    clearData() {
      this.imgCodeSrc = ''
      this.successStatus = false
      this.currentText = '请选择第三方平台'
      this.password_error = ''
      this.account_error = ''
      this.code_error = ''
      this.validAccount = ''
      this.account = ''
      this.code = ''
      this.psw = ''
      this.visible = ''
      this.needPhone = false
      this.sms_code_error = ''
    }
  }
}
